import { useNavigate } from "react-router-dom";
import CreateToken from "../../js/CreateToken";
import { directCancelServiceAPI } from "../../apis/MemberAPICalls";
import { decrypt } from "../../js/encrypt";
import { useSelector } from "react-redux";
import Swal from "sweetalert2";

function ConfirmCancelServiceModal({ status, setStatus, purchasedInfo, type }) {

  const navigate = useNavigate();
  const serviceReducer = useSelector(state => state.serviceReducer);
  const serviceInfo = serviceReducer.serviceInfo;
  
  const closeModal = () => {
    setStatus(false);
  };

  const moveToTerminateService = () => {
    setStatus(false);
    navigate("/terminateService");
  };

  const directCancelService = async () => {
    const resCode = await directCancelServiceAPI(decrypt(sessionStorage.getItem("mem_seq")), purchasedInfo.seq, CreateToken());

    if(1 === resCode) navigate("/history", {replace: true});
    else return;
  };

  const confirmTerminate = () => {
    Swal.fire({
      text: "서비스 해지를 위해 최종 배송 및 수거 일정을 확정해 주세요.",
      confirmButtonText: "확인",
      position: "center",
      confirmButtonColor: "#0064ff",
    })
    .then(res => {
      navigate(`/delivery/order/selectDate?type=D&terminating=P`);
    });
    return;
  }

  // const withdrawMember = async () => {
  //   const resCode = await memberWithdrawAPI(decrypt(sessionStorage.getItem("mem_seq")), CreateToken());
    
  //   if(1 === resCode) {
  //     Swal.fire({
  //       text: "회원탈퇴가 완료됐습니다.",
  //       confirmButtonText: "확인",
  //       position: "center",
  //       confirmButtonColor: "#0064ff",
  //     })
  //     .then(res => {
  //       sessionStorage.clear();
  //       localStorage.removeItem("mem_seq");
  //       navigate("/login");
  //     })
  //     .catch(err => console.error(err));
  //   } else {
  //     Swal.fire({
  //       text: "회원탈퇴 중 오류가 발생했습니다.",
  //       confirmButtonText: "확인",
  //       position: "center",
  //       confirmButtonColor: "#0064ff",
  //     })
  //     .then(res => {return;});
  //   }
  // };

  return (
    <>
      {/* <MemberWithdrawModal status={wStatus} setStatus={setWStatus} purchasedInfo={purchasedInfo}/> */}

      {
        type ?
        <div className={ status ? "modal smallModal active" : "modal smallModal" }>
          <div className="modalNoHeader">
            <div className="modalTxt1">
              {/* 서비스 해지를 신청합니다.<br/>
              회원님의 서비스 이용 만기일인 <span className="bold">{serviceInfo.service_date_ed.substring(0, 4)}년 {serviceInfo.service_date_ed.substring(5, 7)}월 {serviceInfo.service_date_ed.substring(8, 10)}일</span> 이전에 캐비닛 최종 배송을 완료해주세요.<br/><br/>
              캐비닛이 배송되면 내부를 비운 후 즉시 반납(최종 수거)을 완료해야 서비스 해지 절차가 완료됩니다.<br/> */}

              {/* <span className="bold">우수고객 혜택 및<br/>이번달 적립된 무료 크레딧이 사라집니다.</span> */}
              정말로 해지하겠습니까? <br/>
              그 동안 적립된 포인트와 쿠폰이 모두 소멸합니다.
            </div>
          </div>

          <div className="modalButtons">
            <div className="inside">
              <button tabIndex={0} className="buttonCancel button1in2" title="" onClick={closeModal}>취소</button>
              {/* <button tabIndex={0} className="buttonDone button1in2" title="" onClick={moveToTerminateService}>최종 수거 신청</button> */}
              <button tabIndex={0} className="buttonDone button1in2" title="" onClick={confirmTerminate}>확인</button>
            </div>
          </div>
        </div>
        :
        <div className={ status ? "modal smallModal active" : "modal smallModal" }>
          <div className="modalNoHeader">
            <div className="modalTxt1">
              STORR의 프리미엄 서비스를<br/>
              바로 해지 하시겠습니까?
            </div>
          </div>

          <div className="modalButtons">
            <div className="inside">
              <button tabIndex={0} className="buttonCancel button1in2" title="" onClick={closeModal}>결제 유지하기</button>
              <button tabIndex={0} className="buttonDone button1in2" title="" onClick={directCancelService}>결제 해지하기</button>
            </div>
          </div>
        </div>
      }

      <button tabIndex={0} className={ status ? "dimm active" : "dimm" } title="닫기" onClick={closeModal}></button>
    </>
  );
}

export default ConfirmCancelServiceModal;